module.exports = __webpack_public_path__ + "static/img/pz3.3764f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/pz3.png
// module id = Kd6V
// module chunks = 0